import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router'
import { Message, List, FlexboxGrid, IconButton, Icon, Panel, Tag } from 'rsuite'
import { getNotification } from '../../redux/actions/dashboard'
import { startLoading, doneLoading } from '../../utils/loading'
import DashboradToggle from '../../widgets/dashboard/DashboradToggle'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import TableLoadingTemplate from '../../widgets/loadingTemplate/tableLoadingTemplate/TableLoadingTemplate'

export default function Notification({
  config,
  onSettingChange = () => {},
  height,
  expanded = false,
}) {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [expandedPanel, setExpandedPanel] = useState(expanded)
  const history = useHistory()

  useEffect(() => {
    if (config) {
      setSchema(configSchema)
    } else {
      handelGetSchemaDashboard()
    }
  }, [])

  const handelGetSchemaDashboard = async () => {
    setIsLoading(true)
    startLoading()
    setError()
    try {
      let response = await getNotification()
      setSchema(response)
    } catch (e) {
      setError(DEFAULT_ERR_MSG)
    }
    doneLoading()
    setIsLoading(false)
  }

  if (isLoading) {
    return <TableLoadingTemplate />
  }

  return (
    <>
      {error && <Message showIcon type="error" description={error} style={{ marginBottom: 10 }} />}
      {config && (
        <DashboradToggle
          onChange={onSettingChange}
          dashboradName={config.key}
          checked={config.show}
          style={{ marginTop: 20, marginBottom: -15 }}
        />
      )}
      <Panel
        header={<span style={{ fontWeight: 'bold', fontSize: '1rem' }}>{schema?.header}</span>}
        collapsible
        bordered
        expanded={expandedPanel}
        // expanded={schema?.values?.length > 0 && expandedPanel}
        // defaultExpanded //={schema?.values?.length > 0}
        onClick={() => {
          setExpandedPanel(!expandedPanel)
        }}
        style={{ marginTop: 15 }}
        shaded
        classPrefix="rs-panel-alert"
      >
        <List autoScroll hover style={{ height: height || '500px' }}>
          {schema?.values.map((item, index) => {
            // console.log('*********** => ', item)
            return (
              <div
                onClick={() => {
                  if (item.path) {
                    history.push(item.path)
                  }
                }}
                key={index}
              >
                <List.Item
                  key={index}
                  index={index}
                  className="rs-panel-alert"
                  style={{ color: '#ffffff', borderRadius: 0 }}
                >
                  <FlexboxGrid>
                    <FlexboxGrid.Item colspan={20} style={{ paddingLeft: 20 }}>
                      <span>
                        <span
                          style={{
                            marginLeft: '-20px',
                            marginRight: '5px',
                            whiteSpace: 'nowrap',
                            fontWeight: 600,
                          }}
                        >
                          <Tag style={{ backgroundColor: item.color, marginRight: '5px' }}>
                            <Icon icon="tag" style={{ color: 'white' }} />
                          </Tag>
                          {item.code}
                        </span>

                        <br />
                      </span>
                      <span style={{ fontSize: '0.8rem', marginLeft: '20px', fontWeight: 600 }}>
                        {item.statusName}
                        <br />
                      </span>
                      <span style={{ fontSize: '0.6rem', marginLeft: '20px', fontWeight: 600 }}>
                        {item.date}
                        <br />
                      </span>
                    </FlexboxGrid.Item>

                    <FlexboxGrid.Item colspan={4}>
                      <IconButton
                        icon={<Icon icon="chevron-right"></Icon>}
                        style={{ color: '#ffffff', backgroundColor: 'inherit' }}
                        onClick={() => {
                          if (item.path) {
                            history.push(item.path)
                          }
                        }}
                        // href={`/proposal/overview/overview-${urlOverview}?${item.data.statusCode}`}
                      ></IconButton>
                    </FlexboxGrid.Item>
                  </FlexboxGrid>
                </List.Item>
              </div>
            )
          })}
        </List>
      </Panel>
    </>
  )
}

const configSchema = {
  header: 'รายการแจ้งเตือน',
  values: [
    {
      id: '',
      code: 'โครงการ XX-XXXXXX',
      date: 'DD MMM YYYY HH:MM',
      statusCode: '1',
      statusName: 'ชื่อสถานะ',
      color: '#ffdc68',
    },
  ],
}
